export default "__VITE_ASSET__598227d4__"